// app/javascript/controllers/form_protection_controller.js

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["submit"]
  static values = { cooldown: Number }

  connect() {
    this.cooldownValue = this.cooldownValue || 5000 // 5 seconds default
    this.checkSubmissionHistory()
  }

  submitForm(event) {
    const now = Date.now()
    const lastSubmission = localStorage.getItem('lastGuestSubmission')
    
    if (lastSubmission && (now - parseInt(lastSubmission)) < this.cooldownValue) {
      event.preventDefault()
      alert('Please wait a moment before submitting another request.')
      return false
    }
    
    // Disable the submit button to prevent double-clicking
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.textContent = "Submitting..."
    }
    
    // Store the submission time
    localStorage.setItem('lastGuestSubmission', now.toString())
    
    return true
  }

  checkSubmissionHistory() {
    const now = Date.now()
    const lastSubmission = localStorage.getItem('lastGuestSubmission')
    
    if (lastSubmission && (now - parseInt(lastSubmission)) < this.cooldownValue) {
      if (this.hasSubmitTarget) {
        this.submitTarget.disabled = true
        this.submitTarget.textContent = "Please wait..."
        
        setTimeout(() => {
          this.submitTarget.disabled = false
          this.submitTarget.textContent = this.submitTarget.dataset.originalText || "Submit"
        }, this.cooldownValue - (now - parseInt(lastSubmission)))
      }
    }
  }
}
